import * as React from 'react';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';

export type OwnProps = {
    method: 'file' | 'email';
    type: string;
    textKey: string;
    fileTypes: { [type: string]: boolean };
    onChange: React.ChangeEventHandler<HTMLInputElement>;
};

const RawDistributionOption = ({ method, type, textKey, fileTypes, onChange, t }: OwnProps & TranslateProps) =>
    <div>
        <label>
            <input
                type="checkbox"
                id={ `edit-report-${method}-distribution-${type.toLowerCase()}` }
                data-type={ type }
                checked={ !!fileTypes[type] }
                onChange={ onChange }
            />
            { t(textKey) }
        </label>
    </div>
;

export const DistributionOption = compose<OwnProps & TranslateProps, OwnProps>(
    translate(),
)(RawDistributionOption);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/distribution/DistributionOption.tsx